import { actionsFactory, props } from '@ngneat/effects';
import { WeatherAlerts } from '@tmx/data-access';

const weatherActions = actionsFactory('weather');

export const fetchWeatherAlertsSettings = weatherActions.create(
  'Fetch Weather Alerts Settings'
);

export const saveWeatherAlertsSettings = weatherActions.create(
  'Save Weather Alerts Settings',
  props<{ weatherAlerts: WeatherAlerts }>()
);
